<template>
  <v-row>
    <v-col cols="12">
      <v-form ref="form">
        <base-card>
          <v-card-title>Registrar Bines TEF</v-card-title>
          <v-card-text>
            <v-row>
              <v-col
                cols="12"
                sm="3"
              >
                <v-select
                  ref="rol"
                  v-model="dataBines.client"
                  :items="clients"
                  :rules="formRules"
                  item-text="client"
                  item-value="client"
                  label="Cliente"
                  prepend-inner-icon="mdi-account-tie"
                  required
                />
              </v-col>

              <v-col
                cols="12"
                sm="3"
              >
                <v-select
                  ref="rol"
                  v-model="dataBines.typeTef"
                  :items="typeTef"
                  :rules="formRules"
                  item-text="textCredential"
                  item-value="valueCredential"
                  label="Tipo Tef"
                  prepend-inner-icon="mdi-printer-pos"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                sm="1"
              >
                <br>
                <v-icon
                  class="mr-2"
                  color="green darken-3"
                  style="cursor: pointer"
                  @click="downloadFormatExcel(dataBines.typeTef)"
                >
                  mdi-microsoft-excel
                </v-icon>
              </v-col>
              <v-col
                cols="12"
                sm="3"
              >
                <v-file-input
                  id="bExcel"
                  :rules="formRules"
                  @change="loadBinesExcel()"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="4"
              >
                <v-btn
                  class="ma-2"
                  style="background-color:rgb(204 33 40);color:white !important"
                  @click="validateBinesToInsertThem"
                >
                  Importar Bines
                </v-btn>
              </v-col>
            </v-row>
            <v-row
              v-if="importBinesProgress === true"
              class="fill-height"
              align-content="center"
              justify="center"
            >
              <v-col cols="6">
                <v-col
                  class="text-subtitle-1 text-center"
                  cols="12"
                >
                  Procesando y Guardando Bines
                </v-col>
                <v-progress-linear
                  color="red darken-4"
                  indeterminate
                  rounded
                  height="6"
                />
              </v-col>
            </v-row>
            <v-alert
              v-show="successAlert"
              type="success"
              text
            >
              {{ msgSuccessAlert }}
            </v-alert>
            <v-alert
              v-show="warningAlert"
              type="info"
              text
            >
              {{ msgWarningAlert }}
            </v-alert>
          </v-card-text>
        </base-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
  import readXlsFile from 'read-excel-file'
  import { mapState } from 'vuex'
  import { listTef } from '@/data/listTef'

  export default {
    name: 'RegisterBinesTef',

    data () {
      return {
        items: [],
        importBinesProgress: false,
        setDataBines: [],
        permisosRoles: ['administrador'],
        dataBines: {},
        typeTef: listTef,
        dataCredentials: {},
        successAlert: false,
        warningAlert: false,
        msgSuccessAlert: '',
        msgWarningAlert: '',
        formHasErrors: null,
        formRules: [
          (v) => !!v || 'Este campo es requerido',
        ],
      }
    },
    computed: {
      ...mapState('credentialsTef', ['statusBinesResponse']),
      clients () {
        return this.$store.state.credentialsTef.listCredentials
      },
    },
    watch: {
      statusBinesResponse () {
        this.importBinesProgress = false
        const msg = this.$store.state.credentialsTef.statusBinesResponse.Mensaje
        if (!this.$store.state.credentialsTef.statusBinesResponse.Error) {
          this.msgSuccessAlert = msg
          this.successAlert = true
          this.clearForm()
          setTimeout(() => {
            this.successAlert = false
          }, 6000)
        } else {
          this.msgWarningAlert = msg
          this.warningAlert = true
          setTimeout(() => {
            this.warningAlert = false
          }, 6000)
        }
        this.$store.dispatch('credentialsTef/getListCredentials')
      },
      formHasErrors () {
        if (this.formHasErrors === false) {
          this.sendBines()
        }
      },
    },
    methods: {
      clearForm () {
        this.formHasErrors = null
        this.$refs.form.reset()
      },
      loadBinesExcel () {
        const input = document.getElementById('bExcel')
        readXlsFile(input.files[0]).then((rows) => {
          this.items = rows
        })
      },
      sendBines () {
        this.importBinesProgress = true
        this.buildBinesPinpadDatafast()
      },

      buildBinesPinpadDatafast () {
        this.items.forEach((column, index) =>
          column.forEach(() =>
            this.setDataBines[index] = {
              IdCompania: JSON.parse(atob(localStorage.getItem('uid'))).idcompania,
              Cliente: this.dataBines.client,
              BIN: column[0],
              IdRedAdquirente: column[1],
              RedAdquirente: column[2],
              Banco: column[3],
            },
          ),
        )

        this.insertBines(this.setDataBines)
      },

      async insertBines (dataBines) {
        await this.$store.dispatch('credentialsTef/insertBines', { bines: dataBines })
      },

      downloadFormatExcel (typeTef) {
        let format
        if (typeTef === '1') {
          format = 'formato/BinesPinPadDatafast'
        } else if (typeTef === '2') {
          format = 'formato/BinesPinPadMedianet'
        }
        const linkSource = '/' + format + '.xlsx'
        const downloadLink = document.createElement('a')
        const fileName = format + '.xlsx'
        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
      },
      validateBinesToInsertThem () {
        this.formHasErrors = !this.$refs.form.validate()
      },
    },
  }
</script>
